import React, { useState, useRef } from "react";
import { Grid, Button } from "@mui/material";
import ApiPaginateSearch from "../component/ApiPaginateSearch";
import { CustomStyles } from "../component/CustomStyle";
import ApiEndpoints from "../network/ApiEndPoints";
import EmployeeDetailsDialog from "../component/EmployeeDetailsDialog";
import { Sledding } from "@mui/icons-material";
import { useMediaQuery, useTheme } from "@mui/material";
import FilterModal from "../modals/FilterModal";
import DataFilter from "./Biggbarains/Common/DataFilter";

const Employee = () => {
  const [apiData, setApiData] = useState([]);
  const [query, setQuery] = useState("is_employee=1");
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const handleViewMore = (row) => {
    setSelectedEmployee(row);
  };
  const refreshRef = useRef(null);

  const refreshFunc = () => {
    refreshRef.current && refreshRef.current();
  };
  const columns = [
    {
      name: "Full Name",
      selector: (row) => <div>{row.name}</div>,
    },
    {
      name: "Mobile Number",
      selector: (row) => <div>{row.username}</div>,
    },
    {
      name: "Designation",
      selector: (row) => <div>{row.role}</div>,
    },
    {
      name: "Actions",
      selector: (row) => (
        <Button
          variant="outlined"
          size="small"
          onClick={() => handleViewMore(row)}
        >
          View Details
        </Button>
      ),
    },
  ];

  return (
    <>
      <Grid sx={{ mt: 1.5 }}>
        {isSmallScreen ? (
          <FilterModal
            ifNameFilter
            ifMobileFilter
            ifRoleFilter
            setQuary={setQuery}
            setQuery={setQuery}
            queryParam={query}
            handleRefresh={refreshFunc}
          />
        ) : (
          <DataFilter
            ifIdFilter
            ifMobileFilter
            setQuary={setQuery}
            queryParam={query}
            handleRefresh={refreshFunc}
          />
        )}
        <ApiPaginateSearch
          apiEnd={ApiEndpoints.GET_USERS_BIGG}
          columns={columns}
          pagename={"Employee"}
          apiData={apiData}
          setApiData={setApiData}
          tableStyle={CustomStyles}
          queryParam={query}
          refresh={refreshFunc}
        />
      </Grid>

      {selectedEmployee && (
        <EmployeeDetailsDialog
          open={!!selectedEmployee}
          onClose={() => {
            setSelectedEmployee(null);
            refreshFunc();
          }}
          employee={selectedEmployee}
          apiData={selectedEmployee}
        />
      )}
    </>
  );
};

export default Employee;
